import { render } from "./ArePermitsAvailable.vue?vue&type=template&id=1e576942"
import script from "./ArePermitsAvailable.vue?vue&type=script&lang=ts"
export * from "./ArePermitsAvailable.vue?vue&type=script&lang=ts"
script.render = render

export default script